import React from 'react'
import {Grid, makeStyles, Paper} from '@material-ui/core';
import PropTypes from 'prop-types'
import ButtonsBar from './ButtonsBar';
import clsx from 'clsx';

const useStyle = makeStyles(theme => ({
    root: {},
    paper: {
        padding: theme.spacing(1)
    },
}));

function NavigationBar(
    {
        classesObj = {},
        buttons
    }) {

    const classes = useStyle();


    return buttons && buttons.length > 0 ?
        <div
            className={clsx(
                classes.root,
                classesObj.menuBar,
            )}
        >
            <Paper className={clsx(classes.paper, classesObj.menuBarPaper)}>
                <Grid
                    container
                    direction={'column'}
                >
                    <Grid item>
                        <ButtonsBar
                            buttons={buttons}
                        />
                    </Grid>
                </Grid>
            </Paper>
        </div> : null
}

NavigationBar.propTypes = {
    classesObj: PropTypes.object,
    buttons: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        onClick: PropTypes.func,
        variant: PropTypes.oneOf(['outlined', 'contained', 'text'])
    }))
}

NavigationBar.propDefault = {}

export default NavigationBar;
